export class Alert {
  public static ALERT: string = "alert";
  public static CHANGEALERT: string = "changeAlert";
  public static LEADTIMEALERT: string = "leadTimeAlert";
  public static INVENTORYMONITORINGALERT: string = "inventoryMonitoringAlert";
  public static ENVCOMPLIANCEALERT: string = "envComplianceAlert";
}
